import { createFileRoute } from '@tanstack/react-router'
import { NewsletterPage } from '../components/pages'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/newsletter')({
  head: () => staticRouteHead('newsletter', 'en'),
  component: NewsletterPage,
})
